/*eslint-disable*/
import api from '../'

class GameStatApi {

    //Post: Stats
    static create(exerciseStat) {
        return api.axios.post('/game-stats', exerciseStat).then(response => response.data.exerciseStat);
    }

    //GET: Stats
    static list(params, cancelToken = null) {
        return api.axios.get('/game-stats', {params, cancelToken}).then(response => response.data);
    }

    //PUT: course/:id
    static update(id, exerciseStat) {
        return api.axios.put('/game-stats/' + id, exerciseStat)
            .then(response => response.data.exerciseStat)
    }

}

export default GameStatApi;
